import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Button, FormControl, OverlayTrigger, Popover } from 'react-bootstrap'
import DatePicker from 'react-16-bootstrap-date-picker'
import { Typeahead } from 'react-bootstrap-typeahead'

import { handleErrorFetchingData } from '../../functions/errorHandling'

import DeliverableDocumentsModal from './DeliverableDocumentsModal'

class Deliverable extends Component {

  constructor(props) {
    super(props)

    const { name, notes, due_date, status, analysts } = this.props.deliverable

    this.state = {
      name,
      notes,
      dueDate: due_date,
      status,
      analysts,
      editable: false,
      showDocuments: false,
    }
  }


  formatDate  = (date) => {
    date = date.split("-")
    const day = date[2]
    const month = date[1]
    const year = date[0]
    return `${month}-${day}-${year}`
  }


  handleDateChange = (date, formattedDate) => {
    if (!!date === false) {
      return
    }

    const today = new Date().getTime()
    const inputDate = new Date(date).getTime()

    const { status } = this.state

    if (status === 'Past Due' && inputDate > today) {
      return this.setState({ dueDate: date, status: 'On Going' })
    } else if (status === 'On Going' && inputDate < today) {
      return this.setState({ dueDate: date, status: 'Past Due' })
    } else {
      return this.setState({ dueDate: date })
    }
  }

  handleSaveClick = () => {
    const { name, notes, dueDate, status, analysts } = this.state

    swal({
      text: "Editing the deliverable... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false
    })
    axios({
      method: "PATCH",
      url: this.props.deliverable.url,
      headers:{
        "Authorization":"Bearer " + localStorage.getItem("token")
      },
      data: {
        name,
        notes,
        status,
        due_date: new Date(dueDate).toJSON().split("T")[0],
        analysts: analysts.map(user => user.url),
      }
    })
    .then(response => {
      swal({
        title: "Success",
        text: "Deliverable saved successfully",
        icon: "success",
        button: "Continue",
      })
      const updatedDeliverable = {
        ...this.props.deliverable,
        name,
        notes,
        status,
        analysts,
        due_date: new Date(dueDate).toJSON().split("T")[0],
      }
      this.props.editDeliverable(updatedDeliverable)
      this.handleCancelClick()
    })
    .catch(error => {
      const message = "There was an error editing the deliverable"
      handleErrorFetchingData(error, message)
    })
  }

  handleCancelClick = () => {
    const { name, notes, due_date, status } = this.props.deliverable

    this.setState({
      name,
      notes,
      dueDate: due_date,
      status,
      editable: false
    })
  }

  toggleShowDocuments = () => this.setState({ showDocuments: !this.state.showDocuments })

  removeDeliverable = () => {
    const { deliverable } = this.props
    swal({
      text: "Deleting the deliverable... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false
    })
    axios({
      method: "DELETE",
      url: deliverable.url,
      headers:{
        "Authorization":"Bearer " + localStorage.getItem("token")
      }
    })
    .then(response => {
      swal({
        title: "Success",
        text: "Deliverable deleted",
        icon: "success",
        button: "Continue",
      })
      this.props.deleteDeliverable(deliverable.id)
    })
    .catch(error => {
      const message = "There was an error deleting the deliverable"
      handleErrorFetchingData(error, message)
    })
  }

  render () {
    const { deliverable, documentRoute, uniqueUserOptions } = this.props

    const { showDocuments, name, dueDate, status, analysts, notes } = this.state

    const notesPopover = (
      <Popover id="deliverable-notes-popover" title={deliverable.name}>
        <h5>Notes</h5>
        <p>
          {deliverable.notes || "No notes to display"}
        </p>
      </Popover>
    )

    const deletePopover = (
      <Popover id="deliverable-notes-popover" title='Delete Deliverable?'>
        <p>
          Are you sure you want to delete {deliverable.name}?
        </p>
        <br/>
        <br/>
        This action <strong> cannot be undone.</strong>
        <br/>
        <br/>
        <center>
          <Button
            bsStyle="danger"
            onClick={this.removeDeliverable}
          >
            Delete
          </Button>
        </center>
      </Popover>
    )

    return (
      <Fragment>
        {/* carouselIndex & carouselDirection props set the page of the modal to show either show uploaded documents or the file uploader and direction on button click that the modal's carousel will move in */}
        <DeliverableDocumentsModal
          show={showDocuments}
          toggleShow={this.toggleShowDocuments}
          deliverable={deliverable}
          documents={deliverable.documents}
          documentRoute={documentRoute}
          addDeliverableDocument={this.props.addDeliverableDocument}
          deleteDeliverableDocument={this.props.deleteDeliverableDocument}
          carouselIndex={deliverable.documents && deliverable.documents.length > 0 ? 0 : 1}
          carouselDirection={deliverable.documents && deliverable.documents.length > 0 ? 'prev' : 'next'}
        />
        {this.state.editable ?
          <Fragment>
            <tr className="Deliverable">
              <td>
                <FormControl
                  type="text"
                  value={name}
                  onChange={(e) => this.setState({name: e.target.value})}
                />
              </td>
              <td>
                <DatePicker
                  value={dueDate}
                  dateFormat="MM-DD-YYYY"
                  weekStartsOn={1}
                  calendarContainer={document.body}
                  showClearButton={false}
                  onChange={this.handleDateChange}
                />
              </td>
              <td>
                <FormControl
                  componentClass="select"
                  value={status}
                  onChange={(e) => this.setState({status: e.target.value})}
                  placeholder="select"
                >
                  <option value="On Going">On Going</option>
                  <option value="Completed">Completed</option>
                  <option value="Not Started">Not Started</option>
                  <option value="Past Due">Past Due</option>
                </FormControl>
              </td>
              <td>
                <Typeahead
                  id={'Edit_Deliverable_Analysts'}
                  multiple
                  labelKey={(user) => `${user.first_name} ${user.last_name}`}
                  renderMenuItemChildren={this.props._renderMenuItemChildren}
                  options={uniqueUserOptions}
                  selected={analysts}
                  onChange={(value) => this.setState({ analysts: value })}
                />
              </td>
              <td>
                <Button
                  onClick={this.toggleShowDocuments}
                  disabled={deliverable.documents && deliverable.documents.length < 1}
                >
                  {deliverable.documents && deliverable.documents.length > 0 ?
                    `Documents (${deliverable.documents && deliverable.documents.length ? deliverable.documents.length : '0'})`
                    :
                    "No documents"
                  }
                </Button>
              </td>
              <td>
                <span style={{float:"right"}}>
                  <Button
                    className="edit-icon"
                    onClick={this.handleSaveClick}
                  >
                    Save
                  </Button>&nbsp;
                  <Button
                    className="edit-icon"
                    onClick={this.handleCancelClick}
                  >
                    Cancel
                  </Button>&nbsp;

                  <OverlayTrigger
                    rootClose
                    trigger="click"
                    placement="top"
                    overlay={deletePopover}
                  >
                  <Button
                    className="edit-icon"
                  >
                    Delete
                  </Button>
                  </OverlayTrigger>&nbsp;&nbsp;
                </span>
              </td>
            </tr>
            <tr>
            <td colSpan={4}>
              <FormControl
                name="notes"
                componentClass="textarea"
                value={notes}
                onChange={(e) => this.setState({notes: e.target.value})}
              />
            </td>
            </tr>
          </Fragment>
          :
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom"
            overlay={notesPopover}
          >
            <tr className="Deliverable">
              <td>
                {deliverable.name}
              </td>
              <td>
                {deliverable.due_date ? this.formatDate(deliverable.due_date) : ""}
              </td>
              <td>
                {deliverable.status}
              </td>
              <td>
                {deliverable.analysts.map(user => `${user.first_name} ${user.last_name}`).join(', ')}
              </td>
              <td>
                <Button
                  onClick={this.toggleShowDocuments}
                >
                  {deliverable.documents && deliverable.documents.length > 0 ?
                    `Documents (${deliverable.documents.length})`
                    :
                    "No documents"
                  }
                </Button>
              </td>
              <td>
                <span style={{float:"right"}}>
                  <Button
                    className="edit-icon"
                    onClick={() => this.setState({editable: true})}
                  >
                    Edit
                  </Button>
                </span>
              </td>
            </tr>
          </OverlayTrigger>
        }
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(Deliverable)



// WEBPACK FOOTER //
// ./src/reuseable-components/deliverables/Deliverable.js